// pagination: submit the form to switch to the next search result page
$("#nextPageLink").click(function(e) {
    // call the submit handler
    $("#nextPageForm").submit();
    // prevent the default behavior of the link
    e.preventDefault();
});

// pagination: submit the form to switch to the prev. search result page
$("#prevPageLink").click(function(e) {
    // call the submit handler
    $("#prevPageForm").submit();
    // prevent the default behavior of the link
    e.preventDefault();
});

$("#sortSelect").change(function() {
    $("#sortSelectForm").submit();
});

$("#pageSelect").change(function() {
    $("#selectPageForm").submit();
});
